import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "m3.788 8.76 1.657-5.25A.72.72 0 0 1 6.12 3l5.167.75c.398 0 .713.338.713.75v5.557q-.404.182-.75.443a4 4 0 0 0-.75.75 3.7 3.7 0 0 0-.75 2.25V15H9a.75.75 0 0 1-.75-.75v-4.5H4.463c-.488 0-.833-.502-.675-.99M14.25 3h-1.5v7.5h1.5zM3.293 9.9c.277.383.704.6 1.17.6H7.5v3.75c0 .825.675 1.5 1.5 1.5h.75a.77.77 0 0 0 .57-.262.75.75 0 0 0 .18-.488v-1.5c0-1.148.637-2.137 1.59-2.648.127.24.375.398.66.398h1.5a.74.74 0 0 0 .66-.398.7.7 0 0 0 .09-.352V3a.75.75 0 0 0-.75-.75h-1.5A.75.75 0 0 0 12 3v.195A1.5 1.5 0 0 0 11.355 3l-5.13-.743c-.037-.007-.067-.007-.105-.007a1.46 1.46 0 0 0-1.388 1.035l-1.657 5.25c-.15.465-.068.975.217 1.365",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }